import { Insurance } from '@core/constants/data-types.constants';
import { DefaultRating, Rating } from '@core/models/rating.model';
import { Action, createReducer, on } from '@ngrx/store';
import { fullUpdateRatings } from '@redux/actions/ratings.actions';

export interface RatingsState {
  global: Rating;
  financial: Rating;
  protections: {
    [key in Insurance]: Rating;
  };
  insuranceTargets: {
    [key: string]: Rating;
  };
}

export const initialRatingsState: RatingsState = {
  global: { ...DefaultRating },
  financial: { ...DefaultRating },
  protections: {
    DEATH: { ...DefaultRating },
    EDUCATION: { ...DefaultRating },
    SAVING: { ...DefaultRating },
    RETIREMENT: { ...DefaultRating },
    DECUMULATION: {...DefaultRating}
  },
  insuranceTargets: {}
};

const _ratingsReducer = createReducer(
  initialRatingsState,
  on(fullUpdateRatings, (state, { newRatingsState }) => newRatingsState)
);

export function ratingsReducer(state: RatingsState | undefined, action: Action) {
  return _ratingsReducer(state, action);
}
